import React from "react";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import pdf from "../../Assets/Emisael_Kisler.pdf";

function Downloader() {
  return (
    <div>
      <Row style={{ justifyContent: "center", position: "relative", paddingBottom: "10px", paddingTop: "20px" }}>
        <Button
          variant="dark"
          href={pdf}
          target="_blank"
          style={{ maxWidth: "170px" }}
        >
          &nbsp;Descargar CV
        </Button>
      </Row>
    </div>
  );
}

export default Downloader;
